import { ModelBase, isEmptyOrWhitespace } from "@shoothill/core";
import { IsNotEmpty, NotEquals } from "class-validator";
import { action, observable } from "mobx";

import { IOutputType, OutputType } from "../../Shared";
import { UserDTO, UserModel } from "Views/Project/Commercial/IncomeAndExpenditure/UserModel";

export class AddEditOutputModel extends ModelBase<AddEditOutputModel> {
    // #region Defaults

    //public static readonly DEFAULT_OUTPUTCATEGORIES = [];
    public static readonly DEFULAT_OUTPUTTYES = [];
    public static readonly DEFAULT_ASSIGNEDTOUSERLIST = [];

    //public static readonly DEFAULT_OUTPUTCATEGORY = null;
    public static readonly DEFAULT_OUTPUTTYPE = null;

    public static readonly DEFAULT_REQUIREDBYDATE = "";

    public static readonly DEFAULT_ASSIGN_TO_USER = null;

    // #endregion Defaults

    // #region Related Properties

    @observable
    public outputTypes = observable<OutputType>(AddEditOutputModel.DEFULAT_OUTPUTTYES);

    @observable
    public assignedToUserList = observable<UserModel>(AddEditOutputModel.DEFAULT_ASSIGNEDTOUSERLIST);

    // #endregion Related Properties

    // #region Properties

    public outputId: string | null = null;

    public planOfWorkId: string | null = null;

    @observable
    @NotEquals(null, { message: "Please select an option" })
    public outputType: OutputType | null = AddEditOutputModel.DEFAULT_OUTPUTTYPE;

    @observable
    @NotEquals(null, { message: "Please select an option" })
    public assignedToUser: UserModel | null = AddEditOutputModel.DEFAULT_ASSIGN_TO_USER;

    @observable
    @IsNotEmpty({ message: "Please provide a date" })
    public requiredByDate: string = AddEditOutputModel.DEFAULT_REQUIREDBYDATE;

    public rowVersion: string | null = null;

    // #endregion Properties

    // #region Methods

    @action
    public fromDto(dto: any): void {
        this.outputTypes.replace(
            dto.outputTypes.map((oc: IOutputType) => {
                const outputType = new OutputType();

                outputType.fromDto(oc);

                return outputType;
            }),
        );

        this.assignedToUserList.replace(
            dto.assignedToUsers.map((oc: UserDTO) => {
                const outputType = new UserModel();

                outputType.fromDto(oc);

                return outputType;
            }),
        );

        if (!isEmptyOrWhitespace(dto.outputId)) {
            this.outputId = dto.outputId;
            this.planOfWorkId = dto.planOfWorkId;
            this.assignedToUser = this.assignedToUserList.find((oc) => oc.id === dto.assignToUserId) ?? AddEditOutputModel.DEFAULT_ASSIGN_TO_USER;
            this.outputType = this.outputTypes.find((ot) => ot.id === dto.outputTypeId) ?? AddEditOutputModel.DEFAULT_OUTPUTTYPE;
            this.requiredByDate = dto.requiredByDate;
            this.rowVersion = dto.rowVersion;
        }
    }

    public toDto(): any {
        return {
            outputId: this.outputId,
            planOfWorkId: this.planOfWorkId,
            assignedToUserId: this.assignedToUser?.id,
            outputTypeId: !isEmptyOrWhitespace(this.outputType?.id) ? this.outputType?.id : null,
            newOutputTypeTitle: isEmptyOrWhitespace(this.outputType?.id) ? this.outputType?.displayName : null,
            requiredByDate: this.requiredByDate,
            rowVersion: this.rowVersion,
        };
    }

    // #endregion Methods
}
